module.exports = __webpack_public_path__ + "public/images/slider/filimonova-circle.32f0650136377fb65429780ddceb09df.png";